import {observer} from "mobx-react";
import Currency from "../../../components/currency/currency";
import {FontBody1} from "../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import IconInfo from "../../../components/icons/icon-info/icon-info";
import Icon from "../../../components/icons/icon/icon";
import './summary-card.scss';
import {Tooltip} from "../../../components/tooltip/tooltip";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaRequestStore from "../stores/rma-request-store";

interface IProps {
	rmaRequestStore: RmaRequestStore;
}

const SummarySection: React.FC<IProps> = observer(({ rmaRequestStore}) => {
    
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';

	return (
            <div className={'summary-grid'}>
                
                <div>
                    <FontBody1>{getTranslation('ITEMS_SUBTOTAL', pageScope)}</FontBody1>
                    <FontBody1 variant={FONT_VARIANT.BOLD}>
                        <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.itemsSubtotal}/>
                    </FontBody1>
                </div>
                { rmaRequestStore.itemsAdjustments !== 0 &&
                    <div>
                        <FontBody1>{getTranslation('ADJUSTMENTS', pageScope)}</FontBody1>
                        <FontBody1 variant={FONT_VARIANT.BOLD}>
                            <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.itemsAdjustments}/>
                        </FontBody1>
                    </div>
                }
                { rmaRequestStore.restockingFeeTotal < 0 &&
                    <div>
                        <FontBody1>{getTranslation('RESTOCKING_FEE_TOTAL', pageScope)}</FontBody1>
                        <FontBody1 variant={FONT_VARIANT.BOLD}>
                            <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.restockingFeeTotal}/>
                        </FontBody1>
                    </div>
                }
                { rmaRequestStore.rmaFeesListStore.returnFee.isCharged &&
                    <div>
                        <FontBody1>{getTranslation('RETURN_FEE', pageScope)}</FontBody1>
                        <FontBody1 variant={FONT_VARIANT.BOLD}>
                            <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.getFeeSummary('returnFee')}/>
                        </FontBody1>
                    </div>
                }
                { rmaRequestStore.rmaFeesListStore.labelFee.isCharged &&
                    <div>
                        <FontBody1>{getTranslation('LABEL_FEE', pageScope)}</FontBody1>
                        <FontBody1 variant={FONT_VARIANT.BOLD}>
                            { !rmaRequestStore.isDynamicShippingOptionsSupported() && rmaRequestStore.doesLabelFeeIncludeCost() ?
                              <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}><span dangerouslySetInnerHTML={{__html:getTranslation('FEE_CALCULATED_ON_CREATE', pageScope)}}></span></FontBody2>}>
                                  <Icon Component={IconInfo}/>
                              </Tooltip>
                               : <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.getFeeSummary('labelFee')}/>
                            }
                        </FontBody1>
                    </div>
                }
                <div>
                    <FontBody1>
                        { rmaRequestStore.total > 0
                            ? getTranslation('TOTAL_TO_REFUND', pageScope)
                            : getTranslation('TOTAL_TO_PAY', pageScope)
                        }
                    </FontBody1>
                    <FontBody1 variant={FONT_VARIANT.BOLD}>
                        <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.total} absoluteNumber={true}/>
                    </FontBody1>
                </div>
            </div>
	)
});

export default SummarySection;
